import api, { BULK_TIMEOUT_MS } from "..";
import { playListPassword, playListUsername } from "../../../state";
import { convertItemsToTilesSeries } from "../formatters/ItemFormatter";

const cache = new Map<string, Promise<any>>();

export default function () {
    return (pageIndex: number): Promise<any> => {
        const username = playListUsername();
        const password = playListPassword();
        const apiIdentifier = api.getIdentifier ? api.getIdentifier() : "default";

        const cacheKey = `${apiIdentifier}_${username}_all_series`;

        const url = `/player_api.php?username=${username}&password=${password}&action=get_series`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const result = api
            ._getWithRetry(url, {}, 1, BULK_TIMEOUT_MS, BULK_TIMEOUT_MS)
            .then(series => {
                if (!Array.isArray(series)) {
                    console.warn(`Series streams response is not an array:`, typeof series);
                    cache.delete(cacheKey); // e.g. `false` from an unhealthy proxy — don't pin it as empty
                    return [];
                }

                const tiles = convertItemsToTilesSeries(series);
                console.log(`✅ All series processed: ${tiles.length} tiles`);
                return tiles;
            })
            .catch(error => {
                console.error(`❌ All series API call failed:`, error.message);
                cache.delete(cacheKey);
                return [];
            });

        cache.set(cacheKey, result);
        return result;
    };
}